import React, {Component} from 'react'
import {Button, Input, message, Modal} from 'antd'
import PropTypes from 'prop-types'
import ShirtTemplate from './ShirtTemplate'
import {updateFailedPartials, updateBasketNumber} from "../../../../services/api/3dApi"

class OrderItemTypeContainer extends Component {
    state = {
        visible: false,
        selectedParts: this.props.failedPartials,
    }

    _inputBasket = React.createRef()

    _updateSelectedParts = (part, isAdded) => {
        const {selectedParts} = this.state

        if (isAdded) {
            if (!selectedParts.includes(part)) {
                this.setState({
                    selectedParts: [...selectedParts, part],
                })
            }
        } else {
            const filtered = selectedParts.filter(selected => selected !== part)

            this.setState({
                selectedParts: filtered,
            })
        }
    }

    _updateInvalidParts = async () => {
        try {
            const {selectedParts} = this.state
            const {orderId} = this.props
            const payload = {
                partials: selectedParts,
            }

            const {data: response} = await updateFailedPartials(orderId, payload)

            const {success, error} = response

            if (!success) {
                throw new Error(error)
            }

            this.setState({
                visible: true,
            })
        } catch (e) {
            message.error(e.message, 3)
        }
    }

    _handlePressEnter = e => {
        const {value} = e.target

        const valueFormatted = value.trim().replace(/^#/, '')

        if (!valueFormatted) {
            return null
        }

        this._rqUpdateBasket(valueFormatted)
    }

    _rqUpdateBasket = async (inputValue) => {
        try {
            const {orderId} = this.props
            const payload = {
                basket_number: inputValue,
            }

            const {data: response} = await updateBasketNumber(orderId, payload)

            const {success, error} = response

            if (!success) {
                throw new Error(error)
            }

            this.setState({
                visible: false,
            }, () => {
                message.success('Thêm thành công')

                this.props.onUpdateBasketSuccess()
            })
        } catch (e) {
            message.error(e.message, 3)
        }
    }

    _hideModal = () => {
        this.setState({
            visible: false,
        })
    }

    render() {
        const {selectedParts, visible} = this.state
        const {type} = this.props

        return (
            <div className='OrderItemTypeContainer'>
                <div className='row'>
                    <div className='col-6'>
                        <ShirtTemplate type={type} failedPartials={selectedParts}
                                       onUpdateSelectedPart={this._updateSelectedParts}/>
                    </div>

                    <div className='col-6'>
                        {/*<Button onClick={this._updateInvalidParts} size='large'>Thêm mảnh lỗi</Button>*/}
                    </div>
                </div>

                <Modal title='Nhập mã giỏ hàng' visible={visible} footer={null} width={1000} maskClosable={false}
                       onCancel={this._hideModal}>
                    <Input size='large' autoFocus={true} onPressEnter={this._handlePressEnter} ref={this._inputBasket}
                           defaultValue=''/>

                    <div className='mt-2'>
                        Mảnh đã thêm: {selectedParts.join(', ')}
                    </div>
                </Modal>
            </div>
        )
    }
}

OrderItemTypeContainer.defaultProps = {
    basketNumber: '',
}

OrderItemTypeContainer.propTypes = {
    failedPartials: PropTypes.array,
    basketNumber: PropTypes.string.isRequired,
    onUpdateBasketSuccess: PropTypes.func.isRequired,
}

export default OrderItemTypeContainer
